export default __webpack_public_path__ + "static/mietwagen-2b2e295bae12d7e16afaed134da066ae.png";